export default "__VITE_ASSET__DmvcpMlS__"